import { render, staticRenderFns } from "./anew.vue?vue&type=template&id=2ca9f04e&scoped=true&"
import script from "./anew.vue?vue&type=script&lang=js&"
export * from "./anew.vue?vue&type=script&lang=js&"
import style0 from "./anew.vue?vue&type=style&index=0&id=2ca9f04e&lang=scss&scoped=true&"
import style1 from "./anew.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ca9f04e",
  null
  
)

export default component.exports